import React from 'react';
import { Calendar, ChevronDown, User, X, SlidersHorizontal } from 'lucide-react';

const DATE_PRESETS = [
  { value: 'all', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: 'this_week', label: 'This Week' },
  { value: 'last_7_days', label: 'Last 7 Days' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_30_days', label: 'Last 30 Days' },
  { value: 'this_quarter', label: 'This Quarter' },
  { value: 'this_year', label: 'This Year' },
];

// TODO: replace with a useUsersList() hook once /users/owners endpoint exists.
// Until then, the owner filter is a single 'All Owners' chip — no static
// employee names leaking into the UI.
const OWNER_OPTIONS = ['All Owners'];

const FilterSelect = ({ icon: Icon, value, onChange, options, activeDefault }) => {
  const isActive = value !== activeDefault;
  return (
    <div className="relative flex items-center">
      <Icon className={`absolute left-2.5 w-3 h-3 pointer-events-none z-10 ${isActive ? 'text-indigo-500' : 'text-slate-400'}`} />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`pl-7 pr-6 py-1 text-xs rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer appearance-none transition-all ${
          isActive
            ? 'border border-indigo-200 bg-indigo-50 text-indigo-700 font-medium'
            : 'border border-slate-200 bg-white text-slate-600 hover:border-slate-300'
        }`}
      >
        {options.map((o) => (
          <option key={typeof o === 'string' ? o : o.value} value={typeof o === 'string' ? o : o.value}>
            {typeof o === 'string' ? o : o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-1.5 w-3 h-3 text-slate-400 pointer-events-none" />
    </div>
  );
};

const DashboardFilterBar = ({ filters = {}, onChange }) => {
  const datePreset = filters.datePreset || 'all';
  const owner = filters.owner || 'All Owners';
  const activeCount = (datePreset !== 'all' ? 1 : 0) + (owner !== 'All Owners' ? 1 : 0);

  const set = (key, val) => onChange({ ...filters, [key]: val });

  return (
    <div className="flex-shrink-0 flex items-center gap-2.5 px-4 py-2 bg-white border-b border-slate-100 flex-wrap">
      <div className="flex items-center gap-1.5 text-[11px] font-semibold text-slate-400 uppercase tracking-wider">
        <SlidersHorizontal className="w-3 h-3" />
        Filters
      </div>
      <div className="w-px h-4 bg-slate-200 mx-0.5" />
      <FilterSelect icon={Calendar} value={datePreset} onChange={(v) => set('datePreset', v)} options={DATE_PRESETS} activeDefault="all" />
      <FilterSelect icon={User} value={owner} onChange={(v) => set('owner', v)} options={OWNER_OPTIONS} activeDefault="All Owners" />

      {activeCount > 0 && (
        <button onClick={() => onChange({ datePreset: 'all', owner: 'All Owners' })}
          className="flex items-center gap-1 text-xs text-indigo-600 hover:text-indigo-800 font-medium px-2 py-1 rounded-lg hover:bg-indigo-50 transition-colors">
          <X className="w-3 h-3" />
          Clear {activeCount > 1 ? `(${activeCount})` : ''}
        </button>
      )}

      <div className="ml-auto flex items-center gap-1.5">
        {activeCount > 0 ? (
          <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-indigo-100 text-indigo-600 border border-indigo-200">
            {activeCount} filter{activeCount > 1 ? 's' : ''} active
          </span>
        ) : (
          <span className="text-[11px] text-slate-400">Showing all data</span>
        )}
      </div>
    </div>
  );
};

export default DashboardFilterBar;
